module.exports = __webpack_public_path__ + "img/4.1c0c6adb.jpg";